import {Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Model_Datasource, Model_WorkflowComponent, Model_VariableEnvironnement, TYPE_DEFAULT_VALUE, AbsDSOptionsItems } from 'src/app/app.models';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'app-datasource-orders-dialog',
    templateUrl: './datasource-orders-dialog.component.html',
    styleUrls: ['./datasource-orders-dialog.component.scss']
})
export class DatasourceOrdersDialogComponent implements OnInit {
    datasource: any;
    ORDER_DIRECTIONS: AbsDSOptionsItems[] = [
        { mVALUE_MEMBER: 'ASC', mDISPLAY_MEMBER: "Ascendant" },
        { mVALUE_MEMBER: 'DESC', mDISPLAY_MEMBER: "Descendant" },
    ];
    formGroup = this._formBuilder.group({
        OrderColumn: [null, Validators.required],
        OrderDirection: ['ASC', Validators.required]
    });

    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<DatasourceOrdersDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { datasource: any },
    ) {
        this.datasource = data.datasource;
        if (data.datasource.DS_ORDERS.length > 0) {
            this.formGroup.patchValue({
                OrderColumn: data.datasource.DS_ORDERS[0].OrderColumn,
                OrderDirection: data.datasource.DS_ORDERS[0].OrderDirection,
            });
        }
    }

    ngOnInit() {
    }

    dismiss() {
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.formGroup.invalid) { return; }

        const formValues = this.formGroup.value;
        this.dialogRef.close(formValues);
    }
}